module.exports = __webpack_public_path__ + "static/media/goa7er.0ed08cfa.svg";